import PropTypes from 'prop-types';
import React from 'react';

var Icon = function Icon(_ref) {
  var className = _ref.className,
      id = _ref.id,
      svg = _ref.svg,
      onClick = _ref.onClick;
  return React.createElement("svg", {
    className: className,
    onClick: onClick,
    preserveAspectRatio: "none"
  }, svg(), React.createElement("use", {
    xlinkHref: "#".concat(id)
  }));
};

Icon.displayName = 'Icon';
Icon.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  svg: PropTypes.func.isRequired,
  onClick: PropTypes.func
};
Icon.defaultProps = {
  className: ''
};
export default Icon;